import { of } from "rxjs";
import { actionBuildingUpgradeConfirmationRequest } from "../actionBuildings";
export var pathBuildingUpgradePurchaseInitiate = function (action$, state$, deps) {
    var building = action$.building, premium = action$.premium;
    return of(actionBuildingUpgradeConfirmationRequest(building, premium));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/player-base/buildings/path/pathBuildingUpgradePurchaseInitiate.ts
// module id = 2081
// module chunks = 3